<template>
    <div>
        <sweet-modal ref = "modal1"
                    v-on:close="onClose"    
                    v-bind="config"
                    >
           
            <!--<div v-html="config.body"></div> -->
            <html-renderer-old
                v-if="config.html || config.body"
                :template="'<div>' + (config.html|| config.body )+ '</div>'" 
                
                :app="$store.state.site.content.app"  
                :params="$store.state.site.content.params" 
                >
            </html-renderer-old>

            <div v-for="button, index in config.buttons"  
                :key="_uid"
                slot="button" 
                @click.prevent="button.onClick($event, config.rows, config.index)" 
                :class="button.class">{{button.text}}
            </div>

            <component v-for="slotObj in config.slots" 
                :key="_uid"
                :class="slotObj.styleClasses" 
                @click.prevent="onclick(slotObj.actions)" 
                :is="slotObj.component" 
                v-bind="slotObj"
                >
                {{slotObj.text}}
            </component>
        </sweet-modal>
    </div>
</template>

<script>
    // #
    import { SweetModal, SweetModalTab } from 'sweet-modal-vue';
    // Future me: if this breaks its because the ref'd modules do not have the .vue eg:

    import  { EventBus } from'Js/eventBus';
    export default {
        props: [],
        name: 'sweetmodal',
        data() {
            return {
                config: {},
                defaults: {
                    title: "Modal Title not set",
                    blocking: false,
                    pulseOnBlock: false,
                    hideCloseButton: false,
                    overlayTheme: "light",
                    modalTheme: "light",
                    icon: "",
                    body: "body text not set",
                    slots:[],
                    buttons: [
                        {
                         text: "Ok",
                         class: "btn btn-info btn-square",
                         onClick: this.hideModal
                        }
                        // {
                        //  text: "Button2",
                        //  class: "btn  btn-square"
                        // }
                        ],
                    
                    // SLOTS
                    'boxAction': null,
                    title: null,
                    button: null,
                    default: null
                }
            }
        },

    	components: {
    	    SweetModal,
    	    SweetModalTab,
    	},
        
        methods: {
            showModal: function(config) {
                this.config = Object.assign({}, this.defaults )
                
                config = Object.assign ( config, config.options )
                delete config.options
                
                this.config = Object.assign  (this.config, config) 
                this.$refs.modal1.open()
                
            },
            
            hideModal: function(config) {
                this.$refs.modal1.close()
            },
            
            onclick: function(actions){
                this.$store.dispatch('ACTIONS_QUEUE', actions);
            },
            
            onClose: function(config) {
                // delay because vue set modal delays, else there is cross talk
                // TODO allow support for multiple instances vs replacing same one
                setTimeout(() => Vue.nextTick(this.$store.dispatch('ACTIONS_DO', {} )) , 350)
            }
        },
          
            
        mounted() {
            EventBus.$on('showModal', config => {
                this.showModal(config)
            });
            
            EventBus.$on('hideModal', config => {
                this.hideModal(config)
            });
        }  
        }
        

</script>

<style scoped>
button + button {
    margin-left: 12px;
}
</style>



                            
/***
title	    String	null	Title of the modal, shown at the top
blocking	Boolean	false	If true, user cannot close the modal by clicking on the overlay.
pulse-on-block	Boolean	true	If false, disabled pulse effect when user clicks outside a blocking modal.
icon	String	null	Animated icon to show upon opening the modal. One of these values:
    - success
    - info
    - warning
    - error
hide-close-button	Boolean	false	If true, close button is hidden.
overlay-theme	String	light	Theme of the overlay; light or dark.
modal-theme	String	light	Theme of the modal; light or dark.


SLOTS
box-action	An action to be displayed next to the close button.
title	    Title of the modal, if not given via the title attribute.
button	    Button or Action to be displayed underneath the modal.
default	    Content of the Modal.


*/